import { AdministratorInfo } from 'types/state';
import { normalizeSportingAdminInfo } from 'services/sporting/utils/normalizeSportingAdminInfo';
import { sportingAPI } from 'services/sporting/api';

export const getAdministratorInfos = async (): Promise<AdministratorInfo[]> => {
  const sportingAdmins = await sportingAPI.service.getAdmins();

  return sportingAdmins.map(normalizeSportingAdminInfo.toAdministratorInfo);
};
